<script setup lang="ts">
import { computed } from "vue";
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

const props = defineProps<{ content: string }>();

const md = new MarkdownIt({ html: false, breaks: true, linkify: true });

// Open all links (e.g. docs URLs from the MCP server) in a new browser tab
const defaultLinkOpenRender =
  md.renderer.rules.link_open ?? ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options));

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  tokens[idx].attrSet("target", "_blank");
  tokens[idx].attrSet("rel", "noopener noreferrer");
  return defaultLinkOpenRender(tokens, idx, options, env, self);
};

const HEADING_EMOJI_RE = /^(#{1,6} *)[\p{Emoji_Presentation}\p{Extended_Pictographic}\s]*/gmu;

function stripHeadingEmoji(content: string): string {
  return content.replace(HEADING_EMOJI_RE, "$1");
}

// DOMPurify strips the `target` attribute by default, which would drop the
// `target="_blank"` we set above and cause links to open in the same tab.
// Allow it explicitly so docs links open in a new browser tab.
const html = computed(() => DOMPurify.sanitize(md.render(stripHeadingEmoji(props.content)), { ADD_ATTR: ["target"] }));
</script>

<template>
  <div
    class="chat-markdown markdown-body !t-xs !bg-transparent"
    v-html="html" />
</template>

<style scoped>
.chat-markdown {
  color: inherit;
}
</style>
